import '../../assets/svg/Icons/32/link-gray.svg';
import { CODE_CONNECT_INTEGRATIONS } from '../constants';

import templateUrl from './template.html';

export default class ConnectCodeModal {
  modal;

  constructor(Authentication, $uibModal) {
    'ngInject';

    Object.assign(this, { Authentication, $uibModal });
  }

  async getCode(type) {
    const response = await this.Authentication.sendRequest({
      method: 'post',
      path: `integrations/${type}/link_token`,
    });
    return response?.data?.linkToken;
  }

  open = (integration) => {
    const self = this;

    this.modal = this.$uibModal.open({
      size: '620',
      controllerAs: 'ctrl',
      controller() {
        this.integration = integration;
        this.details = CODE_CONNECT_INTEGRATIONS[integration.type];
        this.connectUrl = this.details.connectUrl || integration.url;
        this.isAnimatingPopup = false;

        this.$onInit = () => {
          this.getCode(integration.type);
        };

        this.getCode = async () => {
          this.loading = true;
          this.error = false;

          try {
            this.code = await self.getCode(integration.type);
          } catch (e) {
            this.error = true;
          }

          this.loading = false;
        };

        this.animateCopyPopup = () => {
          this.isAnimatingPopup = true;
          setTimeout(() => (this.isAnimatingPopup = false), 1100);
        };
      },
      templateUrl,
    });

    return this.modal.result;
  };

  close = (result) => this.modal && this.modal.close(result);
}
